import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import { Calendar } from "../../components/Icons/Icons";
import Loader from "../../components/Loader/Loader";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import { formatEventDateRange, getPlainTextFromWYSIWYG } from "../../utils/helper";
import "./Events.scss";

const color = ["#E75E0D", "#EB9F11", "#ABC710", "#009340", "#CC0370", "#8366A9", "#149BD7"];

const hasText = (value) => Boolean(value && String(value).trim());

const Events = () => {
    const isSmallScreen = useMediaQuery({ minWidth: 320, maxWidth: 767 });
    const navigate = useNavigate();
    const localData = useSelector((state) => state?.localStorage);
    const { micrositeID, tabConfigId } = localData;

    const [loading, setLoading] = useState(true);
    const [responseData, setResponseData] = useState([]);
    const [failedImageIds, setFailedImageIds] = useState({});

    const getEventsData = async () => {
        if (!micrositeID || !tabConfigId) return;

        try {
            setLoading(true);

            const response = await getRequest(
                userapiservice.getEventsMicrositeDetailsTabs(micrositeID, tabConfigId),
                null,
                false
            );

            setResponseData(Array.isArray(response) ? response : []);
        } catch (error) {
            const apiErrorMessage =
                error?.response?.data?.errorName ||
                error?.response?.data?.message ||
                error?.message ||
                "Sorry, something went wrong";

            toast.error(<ToastComponent type="Error" message={apiErrorMessage} />);
            setResponseData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getEventsData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [micrositeID, tabConfigId]);

    const handleImageError = (id) => {
        setFailedImageIds((prev) => ({ ...prev, [id]: true }));
    };

    const onCardClickHandler = (event) => {
        navigate(`/microsite/${event.id}/micrositeDetails`, {
            state: { page: "events", data: event },
        });
    };

    return (
        <div className="events-container">
            {loading ? (
                <Loader />
            ) : (
                <div className="events-card-list">
                    <div className="events-card-grid">
                        {responseData.length > 0 ? (
                            responseData.map((event, i) => {
                                const logoUrl = event?.eventLogo?.url;
                                const showImage = Boolean(logoUrl) && !failedImageIds[event.id];
                                const description = getPlainTextFromWYSIWYG(event?.description);
                                // const moreInfo = getPlainTextFromWYSIWYG(event?.moreInfo);
                                const dateRange = formatEventDateRange(event?.startDate, event?.endDate);

                                return (
                                    <motion.div
                                        key={event.id || i}
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{
                                            duration: 0.8,
                                            delay: 0.5,
                                            ease: [0, 0.71, 0.2, 1.01],
                                        }}
                                        className="events-card"
                                        onClick={() => onCardClickHandler(event)}
                                    >
                                        {isSmallScreen && (
                                            <div className="events-card-title" title={event?.eventName}>
                                                {event?.eventName}
                                            </div>
                                        )}

                                        <div className="events-text-container">
                                            {!isSmallScreen && (
                                                <div className="events-card-title" title={event?.eventName}>
                                                    {event?.eventName}
                                                </div>
                                            )}

                                            {hasText(description) && (
                                                <p className="events-card-description">{description}</p>
                                            )}

                                            {/* {hasText(moreInfo) && (
                                                <p className="events-card-description">{moreInfo}</p>
                                            )} */}

                                            {/* {address && (
                                                venueUrl ? (
                                                    <a
                                                        className="events-card-address"
                                                        href={venueUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        {address}
                                                    </a>
                                                ) : (
                                                    <p className="events-card-address">{address}</p>
                                                )
                                            )} */}
{/* 
                                            {websiteUrl && (
                                                <a
                                                    className="events-card-link"
                                                    href={websiteUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    More information
                                                </a>
                                            )} */}

                                            {dateRange && (
                                                <span className="events-card-date">
                                                    <Calendar />
                                                    {dateRange}
                                                </span>
                                            )}
                                        </div>

                                        <div
                                            className="events-color-band"
                                            style={{ backgroundColor: color[i % color.length] }}
                                        />

                                        <div className="events-image-container">
                                            {showImage ? (
                                                <div className="events-media">
                                                    <div className="events-slider-img">
                                                        <img
                                                            src={logoUrl}
                                                            alt={event?.eventName || "Event"}
                                                            className="events-preview-img"
                                                            onError={() => handleImageError(event.id)}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="events-media">
                                                    <div className="events-slider-img" />
                                                </div>
                                            )}
                                        </div>
                                    </motion.div>
                                );
                            })
                        ) : (
                            <div className="events-empty-state">
                                Nothing here at the moment!
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Events;
